import { WithArdoqPersistent } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';

export type SolutionMetadata = {
  isBundleSource: boolean;
  sourceBundleId: string | null;
  sourceBundleName: string | null;
};

export const DEFAULT_SOLUTION_METADATA: SolutionMetadata = {
  isBundleSource: false,
  sourceBundleId: null,
  sourceBundleName: null,
};

export const getSolutionMetadata = (
  asset: WithArdoqPersistent
): SolutionMetadata => {
  const persistent = asset['ardoq-persistent'] ?? asset.ardoqPersistent;
  const bundleCopy = persistent?.['bundle-copy'];
  const camelBundleCopy = persistent?.bundleCopy;
  const sourceBundle =
    bundleCopy?.['source-bundle'] ?? camelBundleCopy?.sourceBundle;
  return {
    isBundleSource: isTruthy(bundleCopy ?? camelBundleCopy),
    sourceBundleId: sourceBundle?._id ?? null,
    sourceBundleName: sourceBundle?.name ?? null,
  };
};
